export default {
    methods: {
        /**
         * Simple URL helpers
         *
         * @param path
         * @returns {`${*}/${string}`}
         */
        adminUrl: (path) => { return `${window.OptimizeTemplates.admin_url}${path}` },
        restUrl:  (path) => { return `${window.OptimizeTemplates.rest_url}${path}` },
        imgUrl:   (path) => { return `${window.OptimizeTemplates.img_url}/${path}` },

        /**
         * Translate strings
         *
         * @param str
         * @returns {*}
         */
        $e: str => {
            return str
        },

        /**
         * Open up OP3 editor in overlay
         *
         * @returns {boolean}
         */
        openEditor(postId) {
            return !!OP3.Wrapper.Editor.open(postId)
        },

        /**
         * Hide/close all modals
         */
        closeAllModals() {
            this.$vfm.hideAll()
        },

        /**
         * Check template tiers
         *
         * @param {*} tiers
         * @returns
         */
        userHasTiers(tiers) {
            if (! tiers || !tiers.length) return true

            // Get the user's tier
            let userTier = window.OptimizeTemplates.tier_id
            // userTier = 'essential'

            // And compare
            return tiers.includes(userTier)
        }
    },
}
